import filtersReducer from './filters';
import searchReducer from './search';
import languageReducer from './language';
import provinceReducer from './province';
import headerReducer from './header';
import geolocationReducer from './geolocation';
import contestsReducer from './contests';

const rootReducer = (state = {}, action) => {
    return {
        contests: contestsReducer(state.contests, action),
        filters: filtersReducer(state.filters, action),
        geolocation: geolocationReducer(state.geolocation, action),
        header: headerReducer(state.header, action),
        search: searchReducer(state.query, action),
        language: languageReducer(state.language, action),
        province: provinceReducer(state.province, action),
    }
};

export default rootReducer;